import { Suspense, type ReactNode } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { Notification } from "@/components/admin/notification";
import { Error } from "@/components/admin/error";
import { Skeleton } from "@/components/ui/skeleton";

import { DataImportProvider } from "../dataImport/DataImportProvider";
import { useConfigurationLoader } from "../root/useConfigurationLoader";
import { AdvisorCodePrompt } from "../sales/AdvisorCodePrompt";
import Header from "./Header";

export const Layout = ({ children }: { children: ReactNode }) => {
  useConfigurationLoader();
  return (
    <DataImportProvider>
      <div className="flex items-stretch min-h-screen bg-background">
        <Header />
        <main
          className="flex-1 min-w-0 max-w-screen-xl mx-auto p-4"
          id="main-content"
        >
          <ErrorBoundary FallbackComponent={Error}>
            <Suspense
              fallback={<Skeleton className="h-12 w-12 rounded-full" />}
            >
              {children}
            </Suspense>
          </ErrorBoundary>
        </main>
      </div>
      {/* Almikia Epic E3b (TASK-067): asks a clave-less asesora for her
          advisor code right after sign-in. */}
      <AdvisorCodePrompt />
      <Notification />
    </DataImportProvider>
  );
};
